<template>
  <div class="animated fadeIn">
    <b-card class="card-border px-2 mt-4">
      <b-card-title><i class="fa fa-bar-chart"></i> &nbsp;Analytics</b-card-title>
      <b-card-sub-title
        >Manage settings and layout for all company dashboard features</b-card-sub-title
      >
      <br />
      <!-- Filter  -->
      <b-row class="mt-2 mb-4">
        <b-col sm="6" md="6" lg="6">
          <b-button
            v-b-popover.hover.right="'Toggle to show/hide filter options'"
            @click="
              filterOptions = !filterOptions;
              configurationDashboard = false;
            "
            class="filter"
          >
            FILTER OPTIONS
          </b-button>
        </b-col>
        <b-col sm="6" md="6" lg="6" class="text-right">
          <b-button
            v-b-popover.hover.right="'Toggle to show/hide configure dashboard'"
            @click="
              configurationDashboard = !configurationDashboard;
              filterOptions = false;
            "
            class="filter"
          >
            CONFIGURE COMPANY DASHBOARD
          </b-button>
        </b-col>
        <b-col sm="12">
          <!-- Collapsible Filter Options -->
          <b-collapse id="collapse-1" class="mt-2" v-model="filterOptions">
            <b-card>
              <b-row no-gutters>
                <b-col lg="6" md="10" sm="12">
                  <b-form-group label="Company">
                    <v-select
                      class="style-chooser"
                      label="text"
                      placeholder=" - Please select - "
                      :options="companyAccessOptions"
                      :reduce="(company) => company.value"
                      v-model="filterBy.company"
                    >
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          No results found for
                          <em>
                            <strong>{{ search }}</strong>
                          </em>
                        </template>
                        <em :style="{ opacity: 0.5 }" v-else>
                          Start typing to search for a company
                        </em>
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row no-gutters>
                <b-col lg="4" md="6" sm="12" class="mr-4">
                  <b-form-group label="Date From">
                    <input
                      type="month"
                      class="form-control"
                      v-model="filterBy.dateFrom"
                    />
                  </b-form-group>
                </b-col>
                <b-col lg="4" md="6" sm="12">
                  <b-form-group label="Date To">
                    <input type="month" class="form-control" v-model="filterBy.dateTo" />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row no-gutters>
                <b-col sm="12">
                  <b-button class="mr-1" variant="success" @click="retrieveData">
                    Generate
                  </b-button>
                  <b-button class="mr-1" variant="primary" @click="resetFilters">
                    Reset
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-collapse>

          <!-- Collapsible Configure Company Dashboard -->
          <b-collapse id="collapse-2" class="mt-2" v-model="configurationDashboard">
            <b-card>
              <b-row no-gutters>
                <b-col lg="6" md="10" sm="12">
                  <b-form-group label="Company">
                    <v-select
                      class="style-chooser"
                      label="text"
                      placeholder=" - Please select - "
                      multiple
                      :options="companyAccessOptions"
                      :reduce="(company) => company.value"
                      v-model="dashboardParam.companies"
                    >
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          No results found for
                          <em>
                            <strong>{{ search }}</strong>
                          </em>
                        </template>
                        <em :style="{ opacity: 0.5 }" v-else>
                          Start typing to search for a company
                        </em>
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row no-gutters>
                <b-col lg="12" md="12" sm="12" class="mr-4">
                  <b-form-group label="Select Graph to Display">
                    <small
                      >Manage settings and layout for all company dashboard
                      features</small
                    >
                    <div class="checkbox-grid mt-4">
                      <label
                        v-for="option in chartOptions"
                        :key="option.value"
                        class="checkbox-item"
                      >
                        <input
                          type="checkbox"
                          :value="option.value"
                          v-model="dashboardParam.chartTypes"
                        />
                        {{ option.text }}
                      </label>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row no-gutters>
                <b-col sm="12">
                  <b-button class="mr-1" variant="success" @click="saveAnalytics">
                    Generate
                  </b-button>
                  <b-button class="mr-1" variant="primary" @click="clearAnalyticsParam">
                    Reset
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-collapse>
        </b-col>
      </b-row>

      <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#20A8D8"
        :is-full-page="false"
      />
      <!-- Charts -->
      <ConfiguredCharts
        v-if="hasMetricsData"
        :chartOptions="
          configurationDashboard ? dashboardParam.chartTypes : selectedCharts
        "
        :metricsData="metricsData"
        :assetTypeOptions="allAssetTypeOptions"
        :selectedCompany="filterBy.company.id"
      ></ConfiguredCharts>
    </b-card>
  </div>
</template>

<script>
// Utils
import { DateUtil } from "@/utils/dateutil";
import { DropDownItemsUtil } from "@/utils/dropDownItemsUtil";

// API
import dashboardApi from "@/api/dashboardApi";
import analyticsApi from "@/api/analyticsApi";

// DAO
import dashboardDAO from "@/database/dashboard";

// Others
import config from "@/config/env-constants";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import _ from "lodash";

export default {
  name: "dasboard-analytics",
  components: {
    Loading,
    ConfiguredCharts: () => import("@/views/commons/charts/ConfiguredCharts"),
  },
  computed: {
    selectedCharts() {
      if (this.isSuperAdmin) {
        return config.chartOptions.map((x) => x.value);
      } else {
        return this.companyAnalytics ? this.companyAnalytics : [];
      }
    },
    hasMetricsData() {
      return !_.isEmpty(this.metricsData);
    },
  },
  data() {
    return {
      // Filter Options
      companyAccessOptions: [],
      chartOptions: [],

      filterBy: {
        company: { ...config.companyDefaultValue },
        dateFrom: "",
        dateTo: "",
      },

      dashboardParam: {
        chartTypes: [],
        companies: [],
        defaultCharts: [],
      },

      // Asset Location Map
      allCompanyOptions: [],
      allAssetTypeOptions: [],

      allCompaniesObj: {},
      allAssetTypesObj: {},
      metricsData: {},

      filterOptions: false,
      configurationDashboard: false,

      isSuperAdmin: this.$store.getters.isSuperAdmin,
      isManager: this.$store.getters.isManager,
      loggedUser: this.$store.getters.loggedUser,
      loggedUserCompany: this.$store.getters.loggedUserCompany,
      companyAnalytics: this.$store.getters.companyAnalytics,
      defaultAnalytics: this.$store.getters.companyDefaultAnalytics,

      assetPoolListener: null,
      dispatchListener: null,
      inventorySessionListener: null,

      // Check for loader
      isLoading: false,
    };
  },
  async mounted() {
    try {
      // Don't initiate data retrieval when the account is not authenticated
      if (!this.$store.getters.isAuthenticated) {
        return;
      }

      // show loading indicator
      this.isLoading = true;

      // Company Filter Options
      this.allCompaniesObj = {
        ...this.$store.getters.companies,
        ...this.$store.getters.connectedCompanies,
      };
      this.allCompanyOptions = DropDownItemsUtil.retrieveCompanies(this.allCompaniesObj);

      // Asset Type Filter Options
      this.allAssetTypesObj = { ...this.$store.getters.assetTypes };
      this.allAssetTypeOptions = DropDownItemsUtil.retrieveAssetTypes(
        this.allAssetTypesObj,
        true
      );

      this.initFilterOptions();

      // Set allowed options
      if (this.isSuperAdmin) {
        this.chartOptions = [...config.chartOptions];
      } else {
        this.chartOptions = config.chartOptions.filter((option) =>
          this.defaultAnalytics.includes(option.value)
        );
      }

      await this.retrieveData();
    } catch (_error) {
      console.log(_error);
      this.$toaster.error("Error loading data. Please reload the page again.");
    }

    // hide loading indicator
    this.isLoading = false;
  },
  watch: {
    "$store.getters.companies": {
      handler() {
        this.syncCompanies();
      },
      deep: true,
      immediate: true,
    },
    "$store.getters.connectedCompanies": {
      handler() {
        this.syncCompanies();
      },
      deep: true,
      immediate: true,
    },
    "$store.getters.assetTypes": {
      handler(val) {
        this.syncAssetTypes();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    syncCompanies() {
      this.allCompaniesObj = {
        ...this.$store.getters.companies,
        ...this.$store.getters.connectedCompanies,
      };
      this.allCompanyOptions = DropDownItemsUtil.retrieveCompanies(this.allCompaniesObj);
      this.companyAccessOptions = [];

      if (this.isSuperAdmin) {
        this.companyAccessOptions = DropDownItemsUtil.retrieveAllCompanyAccess(
          this.allCompaniesObj
        );
      } else {
        // Add Sub Companies of the Current Company
        if (
          this.loggedUser.type === config.managerRole ||
          this.loggedUser.type === config.superAdminRole
        ) {
          let currCompanyId = this.loggedUserCompany.id;
          let companiesObj = _.filter(this.allCompaniesObj, (o) => {
            return o.id === currCompanyId || o.parentCompanyId === currCompanyId;
          });
          this.companyAccessOptions = DropDownItemsUtil.retrieveAllCompanyAccess(
            companiesObj
          );
        }

        // Add Company Access Options
        if (this.loggedUser.companyAccess) {
          let companyAssetOptions = DropDownItemsUtil.retrieveAllCompanyAccess(
            this.loggedUser.companyAccess
          );

          let companyNames = _.map(this.companyAccessOptions, "text");
          _.forEach(companyAssetOptions, (o) => {
            if (!companyNames.includes(o.text)) {
              this.companyAccessOptions.push(o);
            }
          });
        }
      }
    },
    syncAssetTypes() {
      this.allAssetTypesObj = { ...this.$store.getters.assetTypes };
      this.allAssetTypeOptions = DropDownItemsUtil.retrieveAssetTypes(
        this.allAssetTypesObj,
        true
      );
    },
    initFilterOptions() {
      this.companyAccessOptions = [];

      if (this.isSuperAdmin) {
        this.companyAccessOptions = DropDownItemsUtil.retrieveAllCompanyAccess(
          this.allCompaniesObj
        );
      } else {
        // Add Sub Companies of the Current Company
        if (
          this.loggedUser.type === config.managerRole ||
          this.loggedUser.type === config.superAdminRole
        ) {
          let currCompanyId = this.loggedUserCompany.id;
          let companiesObj = _.filter(this.allCompaniesObj, (o) => {
            return o.id === currCompanyId || o.parentCompanyId === currCompanyId;
          });
          this.companyAccessOptions = DropDownItemsUtil.retrieveAllCompanyAccess(
            companiesObj
          );
        }
      }

      this.resetFilters();
    },
    resetFilters() {
      // reset to default
      this.filterBy = {
        company: DropDownItemsUtil.getCompanyAccessItem(this.loggedUserCompany),
        dateFrom: DateUtil.currMonthYear(),
        dateTo: DateUtil.currMonthYear(),
      };

      // reset validation
      this.$validator.reset();
      this.errors.clear();
    },
    async retrieveData() {
      await this.getAnalyticsData();
      
      this.assetPoolListener = dashboardDAO.getDashboardListener(
        this.filterBy,
        this.getAnalyticsData,
        "assetPoolDistributions"
      );
      this.dispatchListener = dashboardDAO.getDashboardListener(
        this.filterBy,
        this.getAnalyticsData,
        "dispatches"
      );
      this.inventorySessionListener = dashboardDAO.getDashboardListener(
        this.filterBy,
        this.getAnalyticsData,
        "inventorySessions"
      );
     
    },
    async getAnalyticsData() {
      this.isLoading = true;

      try {
        const { data } = await analyticsApi.getDashboardAnalytics({
          companyId: this.filterBy.company.id,
          fromTimeStamp: DateUtil.getStartOfMonthTimestamp(this.filterBy.dateFrom),
          toTimeStamp: DateUtil.getEndOfMonthTimestamp(this.filterBy.dateTo),
        });

        this.metricsData = { ...data };
      } catch (_error) {
        console.log(_error);
        this.$toaster.error("Error loading data. Please reload the page again");
      }

      this.isLoading = false;
    },
    // Analytics Related
    async saveAnalytics() {
      if (this.dashboardParam.companies.length == 0) {
        this.$toaster.warning("Please select at least 1 company");
        return;
      }

      if (this.dashboardParam.chartTypes == 0) {
        this.$toaster.warning("Please select at least 1 chart");
        return;
      }

      this.isLoading = true;

      try {
        this.dashboardParam.defaultCharts = this.isSuperAdmin
          ? [...this.dashboardParam.chartTypes]
          : [...this.defaultAnalytics];

        let { data } = await analyticsApi.saveAnalytics(this.dashboardParam);

        if (!this.isSuperAdmin) {
          this.$store.dispatch("setCompanyAnalytics", {
            defaultAnalytics: this.defaultAnalytics,
            analytics: [...this.dashboardParam.chartTypes],
          });
        }

        this.$toaster.success("Analytics saved successfully");
      } catch (ex) {
        console.log(ex);
        this.$toaster.error("Error saving analytics");
      }
      this.isLoading = false;
    },
    clearAnalyticsParam() {
      this.dashboardParam = {
        companies: [],
        chartTypes: [],
      };
    },
  },
};
</script>

<style scoped>
.stat-label {
  font-size: 14px;
  margin-bottom: 0px;
}

.stat-label-dark {
  font-size: 14px;
  margin-bottom: 0px;
  color: #0c243b;
  font-weight: bold;
}

.stat-caption {
  font-size: 13px !important;
  color: #0c243b;
}

.stat-caption-dark {
  font-size: 12px !important;
  color: #0c243b;
  font-weight: bold;
}

.assetMetricsFont {
  font-family: monospace;
  font-weight: bold;
  font-size: 22px;
  color: #0c243b !important;
}

/* Backgrounds */
.bg-on-hand {
  background-color: #bfecff;
}

.bg-dispatch {
  background-color: #ff8080;
}

.bg-in-transit {
  background-color: #f6f193;
}

.bg-received {
  background-color: #a1d6b2;
}

.checkbox-grid {
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(5, auto);
  grid-template-columns: repeat(3, auto);
}

.checkbox-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
}

.checkbox-item input[type="checkbox"] {
  margin-right: 8px;
}
</style>
